import React,{useState,useEffect} from "react";
import { Container, Row, Col, Button ,Carousel } from "react-bootstrap";
import "./Home.css";
import homeBg from "../../asset/homebg.webp";
import lineImg from "../../asset/line.webp";
import accountImg from "../../asset/account.webp";
import managementImg from "../../asset/management.webp";
import tdsImg from "../../asset/tds.webp";
import taxationImg from "../../asset/taxation.webp";
import auditImg from "../../asset/audit.webp";
import businessImg from "../../asset/business.webp";
import professionalismImg from "../../asset/professional.webp";
import choiceImg from "../../asset/choice.webp"
import recImg from "../../asset/rectan.webp";
import questionMarkImg from "../../asset/question.webp";
import peopleThinkImg from "../../asset/timage1.webp";
import Gimage2 from "../../asset/Gimage2.webp";
import Gimage3 from "../../asset/Gimage3.webp";
import Gimage4 from "../../asset/Gimage4.webp";
import Gimage7 from "../../asset/Gimage7.webp";
import LineImg from "../../asset/line4.webp";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

import { Card } from "react-bootstrap";

const Home = () => {

  const [chunkSize, setChunkSize] = useState(3);
  useEffect(() => {
    const updateChunkSize = () => {
      if (window.innerWidth < 768) {
        setChunkSize(1); // mobile
      } else if (window.innerWidth < 992) {
        setChunkSize(2); // tablet
      } else {
        setChunkSize(3); // desktop
      }
    };
    updateChunkSize();
    window.addEventListener("resize", updateChunkSize);
    return () => window.removeEventListener("resize", updateChunkSize);
  }, []);


   const testimonials = [
    {
      name: "Sophia Kulkarni",
      title: "National Business Head, Raywood Global, CA, USA.",
      desc: "As an international firm expanding into India, we needed a partner who could navigate compliance and regulations effortlessly. Their team not only simplified the process but also provided ongoing strategic advice.",
      img: Gimage2,
    },
    {
      name: "Cherry Cameron",
      title: "Founder, GreenLife Enterprises, Pune",
      desc: "From audit to advisory, they handle everything with complete transparency and integrity. I can focus on my work knowing my finances are in safe hands.",
      img: Gimage3,
    },
    {
      name: "Jasmine Roy",
      title: "Director, PixelSoft Technologies, Bangalore",
      desc: "We’ve worked with many consultants before, but the consistency is unmatched. Their dedication ensures peace of mind for us as a growing enterprise.",
      img: Gimage4,
    },
    {
      name: "Rahul Mehta",
      title: "CFO, BrightTech Solutions",
      desc:"As an international firm expanding into India, we needed a partner who could navigate compliance and regulations effortlessly. Their team not only simplified the process but also provided ongoing strategic advice.",
      img: Gimage2,
    },
    {
      name: "Ananya Verma",
      title: "CEO, StartUp Hub",
      desc:"From audit to advisory, they handle everything with complete transparency and integrity. I can focus on my work knowing my finances are in safe hands.",
      img: Gimage7,
    },
    {
      name: "David Lee",
      title: "Founder, InnovateX",
      desc: "We’ve worked with many consultants before, but the consistency is unmatched. Their dedication ensures peace of mind for us as a growing enterprise.",
      img: Gimage2,
    },
  ];
  const slides = testimonials.reduce((acc, _, i, arr) => {
    if (i % chunkSize === 0) acc.push(arr.slice(i, i + chunkSize));
    return acc;
  }, []);

  const services = [
    {
      title: "Accounting Services",
      description:
        "Comprehensive accounting solutions including bookkeeping, financial statements preparation and accounting system setup.",
      image:accountImg
    },
    {
      title: "Management Consultancy",
      description:
        "Strategic business consulting to optimize operations, improve efficiency, and drive sustainable growth.",
      image:managementImg
    },
    {
      title: "TDS Services",
      description:
        "Complete TDS compliance including registration, return filling, and consultation for all TDS requirements.",
      image: tdsImg
    },
    {
      title: "Indirect Taxation",
      description:
        "End-to-end GST solutions covering registration, returns, compliance and advisory.",
      image: taxationImg
    },
    {
      title: "Audit & Assurance",
      description:
        "Professional audit services ensuring compliance, transparency, and accuracy in financial reporting.",
      image: auditImg
    },
    {
      title: "Business Start-up Support",
      description:
        "End-to-end support for new businesses including incorporation, licensing, and initial compliance setup.",
      image:businessImg 
    },
    {
      title: "Other Professional Services",
      description:
        "Additional specialized services including valuation, due diligence, and customized financial solutions.",
      image: professionalismImg 
    },
  ];

  return (
    <div>
      {/* Hero Section */}
      <section
        className="hero-section d-flex flex-column justify-content-between"
        style={{
          backgroundImage: `url(${homeBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "88vh",
          position: "relative",
        }}
      >
        {/* <Container className="hero-overlay text-center">
          <h1>Expert Financial Solutions for Your Business</h1>
          <p>
            Professional chartered accountancy services with years of experience
            in taxation, auditing, and financial consulting. Your trusted partner
            for financial growth and compliance.
          </p>
        </Container> */}
        <div
          className="gallery-hero text-white"
          style={{
            
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "88vh",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          
          }}
        >
        
          <div className="hero-text-container">
    <h1 className="home-heading">
      Expert Financial Solutions for Your Business
    </h1>
    <p className="home-paragraph">
      Professional chartered accountancy services with over years of experience
            in taxation, auditing, and financial consulting. Your trusted partner
            for financial growth and compliance.
    </p>
    </div>
    </div>

        <Container className="hero-buttons d-flex flex-column align-items-end">
          <Button className="consult-btn mb-2">
  <span className="consult-text">Get Consultation</span>
</Button>

         <Button className="services-btn">
  <span className="services-text">Our Services</span>
</Button>

        </Container>
      </section>

     {/* Growth Section */}
      <div className="growth-section py-4">
        <div className="growth-heading-wrapper text-center mb-4">
          <img
            src={lineImg}
            alt="line"
            className="line-img left-line d-none d-md-inline"
          />
          <h2 className="growth-heading text-shadow">
            Building Growth Through <span className="highlight">KNOWLEDGE</span>{" "}
            And <span className="highlight">SERVICES</span>
          </h2>
          <img
            src={lineImg}
            alt="line"
            className="line-img right-line d-none d-md-inline"
          />
        </div>

        <Container>
          <Row className="g-4 justify-content-center">
            {services.map((service, index) => (
              <Col key={index} xs={12} sm={6} md={4} lg={3} className="d-flex">
                <div className="custom-card w-100">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="card-img-top img-fluid"
                  />
                  <div className="card-body">
                    <h5 className="card-title">{service.title}</h5>
                    <p className="card-text">{service.description}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>



  {/***********************choice section**********************************/}
<div className="choice-section container py-0 my-0">
<div style={{ position: "relative", width: "100%", padding: "0px 0" }}>
  {/* Left Line (Mirrored + Rotated) */}
  <img
    src={LineImg}
    alt="Left Line"
    className="choice-left-line"
  />

  {/* Right Line (Original) */}
  <img
    src={LineImg}
    alt="Right Line"
    // style={{
    //   position: "absolute",
    //   top: 0,
    //   right: 0,
    //   height: "100%",
    //   zIndex: 0,
    // }}
      className="choice-right-line"
  />

{/* Middle Section Content */}
  <div style={{ position: "relative", zIndex: 1 }}>
    {/* paste all your middle section code here */}
     <div className="choice-head"
    //  style={{ position: "relative", width: "60%", marginLeft: "70px", marginTop: "80px" }}
     > 

  <img
    src={recImg}
    alt="choice"
    // style={{
    //   width: "69%",
    //   objectFit: "cover",
    //   boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
    //   marginLeft: "20px",
    // }}
    className="rectangle-img"
  />




<h2 className="heading">
  <span className="text-black">Why We're the </span>
  <span className="highlight">Right Choice</span>
  <span className="text-black"> ? </span>
</h2>

</div>










  <div className="choice-header-container">
  <div className="choice-images">
    <img src={questionMarkImg} alt="?" className="question-mark" />
  </div>
</div>







<Row className="choice-row pt-4">
  {/* Image */}
  <div className="choice-img">
    <img src={choiceImg} alt="choice" />
    <div className="overlay-text">Experienced Professionals</div>
  </div>

  {/* Text */}
  <div className="description">
    <p>
      A team of qualified Chartered Accountants with diverse expertise across
      taxation, auditing, advisory, and compliance.
    </p>
  </div>
</Row>
{/* <Row className="align-items-center  choice-row" >
  <div className="mirrored-row">
    
    <div className="description">
      <p>
        We understand that every client is unique and provide personalized
        solutions tailored to specific needs.
      </p>
    </div>


    <div className="mirror-img">
      <img src={choiceImg} alt="mirrored" />
      <div className="overlay-text">Client-Centered Approach</div>
    </div>
  </div>
</Row> */}
<Row className="align-items-center  choice-row  " >
  <div className="mirrored-row">
    {/* Text */}
    <div className="description">
      <p>
       We understand that every client is unique and provide personalized
        solutions tailored to specific needs.
      </p>
    </div>

    {/* Mirrored Image */}
    <div className="mirror-img">
      <img src={choiceImg} alt="mirrored" />
      <div className="overlay-text">Client-Centered Approach</div>
    </div>
  </div>
</Row>

<Row className="choice-row full-width">
  {/* Image */}
  <div className="choice-img">
    <img src={choiceImg} alt="choice" />
    <div className="overlay-text"> Timely compliance & Accuracy</div>
  </div>

  {/* Text */}
  <div className="description">
    <p>
     Deadlines and precision are our priority, ensuring hassle-free compliance and accurate financial reporting.
    </p>
  </div>
</Row>



  <Row className="align-items-center  choice-row full-width " >
  <div className="mirrored-row">
    {/* Text */}
    <div className="description">
      <p>
        We follow the highest ethical standards, keeping our work transparent and trustworthy at every step.
      </p>
    </div>

    {/* Mirrored Image */}
    <div className="mirror-img">
      <img src={choiceImg} alt="mirrored" />
      <div className="overlay-text">Integrity & Transparency</div>
    </div>
  </div>
</Row>

  <Row className="choice-row full-width">
  {/* Image */}
  <div className="choice-img">
    <img src={choiceImg} alt="choice" />
    <div className="overlay-text">End-to-end Solutions</div>
  </div>

  {/* Text */}
  <div className="description">
    <p>
      From accounting and tax planning to audit and business advisory, we provide all services under one roof.
    </p>
  </div>
</Row>

<Row className="choice-row full-width alt-layout">
  {/* For large screens: text + mirrored image side by side */}
  <div className="mirrored-row ">
    <div className="description">
      <p>
          Beyond compliance, we guide you with strategies that support financial stability and sustainable growth.
      </p>
    </div>
    <div className="mirror-img">
      <img src={choiceImg} alt="mirrored" />
      <div className="overlay-text">Focus on Long-Term Growth</div>
    </div>
  </div>
  </Row>

</div>
</div>


</div>


{/************************what people think about us**********************************/}
<Row className="justify-content-center my-2 align-items-center text-center">
  <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
    {/* Left horizontal line */}
    <div style={{ width: "310px", height: "2px", backgroundColor: "#0e5185" }}></div>

    {/* Image with text */}
    <div style={{ position: "relative" }}>
      <img
        src={peopleThinkImg} // replace with your image
        alt="people think"
        style={{
             width: "100%",       // take full width of container
              minWidth: "350px",  
              maxWidth:"400px", // optional max size
              height: "auto",      // maintain aspect ratio
              borderRadius: "10px",
              display: "block",
        }}
      />
      {/* Overlay text */}
      <h2
        className="position-absolute top-50 start-50 translate-middle fw-bold m-0"
        style={{
          fontSize: "1.5rem",
          color: "#000",
          whiteSpace: "nowrap",
            textShadow: "2px 2px 4px rgba(0,0,0,0.3)", // normal soft shadow
        }}
      >
        What People <span style={{ color: "#196910" }}>Think</span> About Us
      </h2>
    </div>

    {/* Right horizontal line */}
    <div style={{ width: "350px", height: "2px", backgroundColor: "#0e5185" }}></div>
  </div>
</Row>


      <Container className="py-4 mb-2">
  <Carousel interval={3000} indicators={true} controls={chunkSize > 1}>
    {slides.map((group, idx) => (
      <Carousel.Item key={idx}>
        <div className="row g-4 justify-content-center">
          {group.map((card, i) => (
<div className="col-lg-4 col-md-6 col-sm-12 d-flex justify-content-center" key={i}>
  <div
    className="card testimonial-card"
    style={{
      width: "350px",
      height: "320px",
      display: "flex",
      flexDirection: "column",
      padding:"0px",
    }}
  >
    <div
      className="card-body d-flex flex-column"
      style={{ flex: 1, padding: 0 }} // remove padding
    >
      <div className="d-flex align-items-center mb-3" style={{ padding: "10px" }}>
        <img
          src={card.img}
          alt={card.name}
          className="rounded me-3"
          style={{ width: "120px", height: "120px", objectFit: "cover" }}
        />
        <div>
          <h5 className="mb-1 text-orange fw-semibold" style={{ fontWeight: "500", fontSize: "1.3rem", fontFamily: "montserrat", textShadow: "2px 2px 4px rgba(0,0,0,0.3)", }}
          >{card.name}</h5>
          <small className="fw-bold text-dark">{card.title}</small>
        </div>
      </div>

      <p
        className="text-secondary mb-0"
        style={{
          flexGrow: 1,
          overflowY: "auto", // allows scrolling if text overflows
          padding: "0 10px 10px 10px", // optional: small padding for text
        }}
      >
        {card.desc}
      </p>
    </div>
  </div>
</div>

          ))}
        </div>
      </Carousel.Item>
    ))}
  </Carousel>
</Container>

    

{/* <Container className="py-4 mb-2">

  <Slider
    dots={true}
    infinite={true}
    speed={500}
    autoplay={true}
    autoplaySpeed={2000}
    arrows={false}
    centerMode={false}   // fixed ✅
    centerPadding="0px"
    slidesToShow={3}     // default for desktop
    slidesToScroll={1}
    responsive={[
      { breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 1 } }, // tablet
      { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1 } }, // mobile
    ]}
  >
    {[
      {
        name: "Sophia Kulkarni",
        title: "National Business Head, Raywood Global, CA, USA.",
        desc: "As an international firm expanding into India, we needed a partner who could navigate compliance and regulations effortlessly. Their team not only simplified the process but also provided ongoing strategic advice.",
        img: Gimage2,
      },
      {
        name: "Cherry Cameron",
        title: "Founder, GreenLife Enterprises, Pune",
        desc: "From audit to advisory, they handle everything with complete transparency and integrity. I can focus on my work knowing my finances are in safe hands.",
        img: Gimage2,
      },
      {
        name: "Jasmine Roy",
        title: "Director, PixelSoft Technologies, Bangalore",
        desc: "We’ve worked with many consultants before, but the consistency is unmatched. Their dedication ensures peace of mind for us as a growing enterprise.",
        img: Gimage2,
      },
      {
        name: "Rahul Mehta",
        title: "CFO, BrightTech Solutions",
        desc: "Their financial expertise saved us from major risks...",
        img: Gimage2,
      },
      {
        name: "Ananya Verma",
        title: "CEO, StartUp Hub",
        desc: "With their support, we scaled faster with fewer compliance issues...",
        img: Gimage2,
      },
      {
        name: "David Lee",
        title: "Founder, InnovateX",
        desc: "They provide clarity and confidence in every audit...",
        img: Gimage2,
      },
    ].map((card, i) => (
      <div key={i} className="px-2">
        <div className="card testimonial-card shadow-sm h-100">
          <div className="card-body d-flex flex-column">

            <div className="d-flex align-items-center mb-3">
              <img
                src={card.img}
                alt={card.name}
                className="rounded me-3"
                style={{ width: "100px", height: "100px", objectFit: "cover" }}
              />
              <div>
                <h5 className="mb-1 text-orange fw-semibold">{card.name}</h5>
                <small className="fw-bold text-dark">{card.title}</small>
              </div>
            </div>

          
            <p className="text-secondary mb-0">{card.desc}</p>
          </div>
        </div>
      </div>
    ))}
  </Slider>
</Container> */}

        
        </div>  {/*closes testimonial carousel*/}
    </div>  // closes main Home wrapper
  );
};

export default Home;